import { A as e, C as t, E as n, M as r, T as i, _ as a, c as o, dl as s, fl as c, g as l, l as u, m as d, n as f, o as p, p as m, r as h, s as g, t as _, v } from "./apiUrls-C_lSY48S.js";
import "@vueuse/core";
//#region src/composables/useCoreApiService.ts
var y = () => s.getConfig().auth, b, x = (e) => {
	if (!e.token) throw Error("Token is required");
	let t = {
		auth: e.token,
		baseUrl: e.baseUrl,
		querySerializer: c(),
		headers: { "x-dmp-feature-flags": "x-dmp-no-tracking" }
	};
	return b = e.baseUrl, e.locale && (t.headers = {
		...t.headers,
		"Accept-Language": e.locale
	}), s.setConfig(t), e.token;
}, S = (e) => {
	s.setConfig({ headers: {
		...s.getConfig().headers,
		"Accept-Language": e
	} });
}, C = async (e) => (await m({
	baseUrl: b,
	query: { shopId: e }
})).data.results, w = async (e) => (await i({
	baseUrl: b,
	body: e
})).data, T = async (e) => (await h({
	baseUrl: b,
	path: { ids: e.join(";") }
})).data, E = async (e) => (await d({
	baseUrl: b,
	path: { notification_group_id: e }
})).data.results, D = async (t, n) => (await e({
	baseUrl: b,
	path: {
		notification_group_id: t,
		notification_template_id: n.path.notification_template_id
	},
	body: n.body
})).data, O = async (e, t) => (await g({
	baseUrl: b,
	path: {
		notification_group_id: e,
		notification_template_id: t
	}
})).data, k = async (e, t) => (await u({
	baseUrl: b,
	path: {
		notification_group_id: e,
		notification_template_id: t
	}
})).data, A = async (e) => {
	await o({
		baseUrl: b,
		path: { notification_group_id: e }
	});
}, j = async (e) => {
	await p({
		baseUrl: b,
		path: { notification_group_id: e }
	});
}, M = async (e, t) => (await r({
	baseUrl: b,
	path: {
		notification_group_id: e,
		notification_template_id: t
	}
})).data, N = async (e, t, n) => {
	let r = n?.useDirectPrinting && n?.printerGroupId ? `application/vnd.shipment_label+pdf+print;printer-group-id=${n?.printerGroupId}` : "application/pdf", i = { ...n?.useDirectPrinting ? { Accept: r } : { Accept: "*/*" } };
	return await v({
		baseUrl: b,
		query: t,
		headers: { ...i },
		path: { ids: e.join(";") },
		signal: AbortSignal.timeout(6e4)
	});
}, P = async (e) => (await l({
	baseUrl: b,
	query: e
})).data.data, F = async (e, t) => (await a({
	baseUrl: b,
	path: { ids: e.join(";") },
	query: t
})).data.data;
function I() {
	return {
		getToken: y,
		initClient: x,
		setAcceptLanguageHeader: S,
		getNotificationGroups: C,
		postNotificationGroups: w,
		deleteNotificationGroups: T,
		getNotificationTemplates: E,
		putNotificationTemplate: D,
		disableNotificationTemplate: O,
		enableNotificationTemplate: k,
		enableAllNotificationTemplatesByGroup: A,
		disableAllNotificationTemplatesByGroup: j,
		sendTestNotification: M,
		getShipmentLabels: N,
		getShipments: P,
		getShipmentsById: F
	};
}
//#endregion
//#region src/composables/useShipmentCapabilitiesService.ts
var L = () => s.getConfig().auth, R = (e = { token: void 0 }) => {
	if (!e.token) throw Error("Token is required");
	let t = {
		baseUrl: f,
		auth: e.token,
		querySerializer: c(),
		headers: { Accept: "application/json;charset=utf-8;version=2.0" }
	};
	return e.environment && e.environment === "acceptance" && (t.baseUrl = _), e.locale && (t.headers = {
		...t.headers,
		"Accept-Language": e.locale
	}), s.setConfig(t), e.token;
}, z = (e) => {
	s.setConfig({ headers: {
		...s.getConfig().headers,
		"Accept-Language": e
	} });
}, B = async (e) => (await t({ body: e })).data.results;
function V() {
	return {
		getToken: L,
		initClient: R,
		setAcceptLanguageHeader: z,
		postShipmentsCapabilities: B
	};
}
//#endregion
//#region src/composables/useShipmentPricingService.ts
var H = () => s.getConfig().auth, U = (e = { token: void 0 }) => {
	if (!e.token) throw Error("Token is required");
	let t = {
		baseUrl: f,
		auth: e.token,
		querySerializer: c(),
		headers: { Accept: "application/json;charset=utf-8;version=2.0" }
	};
	return e.environment && e.environment === "acceptance" && (t.baseUrl = _), e.locale && (t.headers = {
		...t.headers,
		"Accept-Language": e.locale
	}), s.setConfig(t), e.token;
}, W = (e) => {
	s.setConfig({ headers: {
		...s.getConfig().headers,
		"Accept-Language": e
	} });
}, G = async (e) => (await n({ body: e })).data ?? null;
function K() {
	return {
		getToken: H,
		initClient: U,
		setAcceptLanguageHeader: W,
		postShipmentsRates: G
	};
}
//#endregion
export { V as n, I as r, K as t };
